import { PatientTable } from '../../components/patientTable/patientTable.component';
import { IssuesBar } from '../../components/issue/bar/issuesBar.container';
import { StudyRoleClaimValue } from 'src/services/api/api-client';
import { useStudy } from 'src/helpers/hooks/useStudy';
import { useHasStudyClaims } from 'src/helpers/auth/auth-helper';
import { StudyNotFoundError } from 'src/helpers/customErrors/customErrors';
import { InformationPageContainer } from 'src/components/informationPageContainer/InformationPage.Container';
import { useTranslation } from 'react-i18next';

export const Dashboard = () => {
  const { t } = useTranslation();
  const study = useStudy();
  const { hasStudyClaim } = useHasStudyClaims();

  if (!study) {
    throw new StudyNotFoundError();
  }

  if (!study.groups.length) {
    return <InformationPageContainer header={t('ProfileProvider.NoGroups')} text={''} />;
  }

  const { id, isTokenActive, groups, hasTherapy, hasMonitoring, surveys } = study;

  return (
    <div data-test-id="main-page" style={{ display: 'flex', flex: '1 1 auto', overflow: 'auto' }}>
      <PatientTable
        studyId={id}
        isSyncActive={isTokenActive}
        groups={groups}
        surveys={surveys}
        hasTherapy={hasTherapy}
      />
      {hasMonitoring && hasStudyClaim(StudyRoleClaimValue.IssueView) && <IssuesBar />}
    </div>
  );
};
